var c = (i, o, r) => new Promise((p, s) => {
  var n = (e) => {
    try {
      t(r.next(e));
    } catch (a) {
      s(a);
    }
  }, l = (e) => {
    try {
      t(r.throw(e));
    } catch (a) {
      s(a);
    }
  }, t = (e) => e.done ? p(e.value) : Promise.resolve(e.value).then(n, l);
  t((r = r.apply(i, o)).next());
});
import { selfAxios as d } from "@oppein/op-utils";
function f(i) {
  return c(this, null, function* () {
    const {
      data: o
    } = yield d.post(
      "/designordercenter/productionOrder/specialApply/createBigFamilySpecialProcess",
      i
    );
    return o;
  });
}
export {
  f as postCreateBigFamilySpecialProcess
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/request/designordercenter/productionOrder/specialApply/createBigFamilySpecialProcess/post.js
// module id = 1820
// module chunks = 67